import { z } from "zod";
export const AlphaChatStartRequestSchema = z.object({
	workflowId: z.string().optional(),
	message: z.string(),
	automationProposal: z
		.object({
			domain: z.string(),
			intent: z.string(),
			trigger: z
				.object({
					type: z.enum(["schedule", "event", "manual"]),
					cron: z.string().optional(),
					eventKey: z.string().optional(),
				})
				.optional(),
			condition: z
				.object({
					expression: z.string().optional(),
				})
				.optional(),
			steps: z
				.array(
					z.object({
						name: z.string(),
					}),
				)
				.optional(),
		})
		.nullable()
		.optional(),
});

export const AlphaChatContinueRequestSchema = z.object({
	workflowId: z.string().optional(),
	sessionId: z.string(),
	message: z.string(),
});

export const SSEEventSchema = z.discriminatedUnion("event", [
	z.object({
		event: z.literal("chunk"),
		content: z.string(),
	}),
	z.object({
		event: z.literal("done"),
		assistant_message: z.string(),
		spec_markdown: z.string(),
		sessionId: z.string().optional(),
		status: z.enum(["NEED_CLARIFICATION", "CONFIRMED", "ERROR"]).optional(),
		message: z.string().optional(),
		error: z
			.object({
				code: z.string(),
				message: z.string(),
				path: z.string().optional(),
			})
			.optional(),
	}),
	z.object({
		event: z.literal("error"),
		error: z.string(),
	}),
]);

export type AlphaChatStartRequest = z.infer<typeof AlphaChatStartRequestSchema>;
export type AlphaChatContinueRequest = z.infer<typeof AlphaChatContinueRequestSchema>;
export type SSEEvent = z.infer<typeof SSEEventSchema>;
export const AutomationChatLogRequestSchema = z.object({
	workflowId: z.string().optional(),
	chat: z.string(),
	type: z.enum(["MESSAGE", "EDIT_REQUEST"]).optional(),
});

export const AutomationChatLogResponseSchema = z.object({
	success: z.boolean(),
});

export type AutomationChatLogRequest = z.infer<typeof AutomationChatLogRequestSchema>;
export type AutomationChatLogResponse = z.infer<typeof AutomationChatLogResponseSchema>;
export const ChatHistoryItemSchema = z.object({
	chat: z.string(),
	requestedAt: z.string(),
	type: z.enum(["MESSAGE", "EDIT_REQUEST"]),
});

export const AutomationChatHistoryResponseSchema = z.object({
	items: z.array(ChatHistoryItemSchema),
	count: z.number(),
});

export type ChatHistoryItem = z.infer<typeof ChatHistoryItemSchema>;
export type AutomationChatHistoryResponse = z.infer<typeof AutomationChatHistoryResponseSchema>;
